import React, {} from 'react';

import './index.scss';

function SynchronizedPageRegionOptions(props) {

  function handleCopyButtonClick() {

    navigator.clipboard.writeText(JSON.stringify({
      type: 'node',
      data: props.element
    }));

  }

  function renderCopyOption() {

    const properties = {
      type: 'button',
      className: 'copy-button',
      onClick: handleCopyButtonClick
    };

    return <button {...properties}>Copy</button>;

  }

  function renderUnsynchronizeOption() {

    const properties = {
      type: 'button',
      className: 'unsynchronize-button',
      onClick: props.onUnsynchronize
    };

    return <button {...properties}>Unsync</button>;

  }

  function renderMain() {

    return <div className="synchronized-page-region-options-main">
      {renderCopyOption()}
      {renderUnsynchronizeOption()}
    </div>;

  }

  return renderMain();

}

export default SynchronizedPageRegionOptions;